import { motion } from "framer-motion";
import { Chip } from "@scripts/react/components/Chip";

export const SidebarHeader = ({
    title,
    description,
    showImageCountChip,
    currentImageCount,
    totalImagesNeeded
}: {
    title: string;
    description?: string | React.ReactNode;
    showImageCountChip?: boolean;
    currentImageCount?: number;
    totalImagesNeeded?: number;
}) => {
    return (
        <motion.div className="header">
            <div className="flex items-center gap-2">
                <h2>{title}</h2>
                {showImageCountChip &&
                    currentImageCount !== undefined &&
                    totalImagesNeeded !== undefined && (
                        <>
                            <Chip color="gray" className="text-xs">
                                <i className="far fa-image" />
                                {currentImageCount}/{totalImagesNeeded}
                            </Chip>
                        </>
                    )}
            </div>
            {description && <div>{description}</div>}
        </motion.div>
    );
};
